var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"close-icon",attrs:{"small":"","left":"","color":_vm.on ? 'green' : 'grey',"outline":""},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v(_vm._s(_vm.on ? 'mdi-check' : 'mdi-pencil'))])}
var staticRenderFns = []

export { render, staticRenderFns }